import React, { useState, useEffect, useContext } from "react";
import axios from 'axios'
import DataTable from 'react-data-table-component';

import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import './App.css';
import { ArrowBarUp, CardList, Check, PencilFill, Wallet2, X } from "react-bootstrap-icons";

const EDITORAS_UPDATE_API = HOST + '/api/inv/editora/update'

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const DATE_FORMAT = new Intl.DateTimeFormat('es', { weekday: 'long', year: 'numeric', month: 'long', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })

function Editorial() {
  const { setGlobalLoading, formDataToJson, setMailBody, setMailTitle, setShowMesage, getEditoras, getNombreProveedor, editorasList, proveedoresList, rol } = useContext(GlobalContext);

  const [ removeId, setRemoveId ] = useState(null)
  const [ show, setShow ] = useState(false)
  const [ action, setAction ] = useState('Crear Proveedor')

  const [ idEditora, setIdEditora ] = useState({ })
  const [ editora, setEditora ] = useState(null)
  const [ idProveedor, setIdProveedor ] = useState(null)

  useEffect(() => {
    setGlobalLoading( true )
    getEditoras()
  }, []);

  const showForm = (item) => {

    if( item ){
      setAction('Actualizar Editorial')
      setIdEditora(item.idEditora)
      setEditora(item.editora)
      setIdProveedor(item.idProveedor)
    } else {
      setAction('Nueva Editorial')
      setIdEditora(null)
      setEditora(null)
      setIdProveedor(null)
    }

    setShow(true)
  }

  const updateItem = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    var form = document.getElementById('editorialForm');
		var formData = new FormData(form);

    var json = formDataToJson(formData)

    console.log('json to update proveedores', json)

    axios.post(EDITORAS_UPDATE_API, json, {
			headers: { 'content-type': 'application/json' }
    }).then(result => {
      console.log("result update", result.data)
      getEditoras()
      setShow(false)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

    /**************************************** Data Table ****************************************/

    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [filteredItems, setFilteredItems] = useState([]);
  
    const columns = [
      {
        name: <th>Editorial</th>,
        selector: row => row.editora,
        sortable: true,
      },
      {
        name: <th>Proveedor</th>,
        selector: row => getNombreProveedor(row.idProveedor) ? getNombreProveedor(row.idProveedor).razonSocial : "-",
        sortable: true,
      },
      {
        cell: row => 
        <>
          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Editar</Tooltip>}>
            <PencilFill onClick={ () => showForm(row) } className="table-icon" />
          </OverlayTrigger>
        </>,
        width: '70px'
      },
    ];
  
    useEffect(() => {
      if( editorasList.length > 0) {
        let data = []
  
        if(filterText && filterText !== '' ) {
          data = editorasList.filter(
            item => item.editora && item.editora.toLowerCase().includes(filterText.toLowerCase()),
          )
        } else data = editorasList
  
        console.log("data filtered", data)
        setFilteredItems(data);
      }
    }, [ editorasList, filterText ]);
  
    /**************************************** Data Table ****************************************/

  return (
    <>
      <Offcanvas show={show} onHide={ () => setShow(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ action }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="editorialForm" onSubmit={ updateItem }>
            <Container>
              <Row>
                <div>
                  <input type="hidden" name="idEditora" value={ idEditora } />
                  <Container>
                    <Row>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Editorial">
                            <Form.Control required name="editora" value={ editora } onChange={ (e) => setEditora( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Proveedor Principal">
                            <Form.Select required name="idProveedor" value={ idProveedor } onChange={ (e) => setIdProveedor( e.target.value ) }>
                              <option>Selecciona una opción</option>
                              { proveedoresList.map( item => (
                                <option key={ item.idProveedor } value={ item.idProveedor }>{ item.razonSocial }</option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Container>
                  
                  <br/>
                  <div align="center">
                    <button type="button" className="cancel-btn" onClick={ () => setShow(false) } >{ 'Cancelar' }</button>&nbsp;&nbsp;
                    <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                  </div>
                </div>
              </Row>
            </Container>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Container className='main-component'>
        <Row>
          <Col md={ 9 }>
            <div className="section-subtitle"> Lista de Editoriales </div>
            <br/>
          </Col>
          <Col md={ 3 } align="right">
            { parseInt(rol) === 2 && <div className="single-btn" onClick={ () => showForm() } > Nuevo </div> }
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className='mb-3'>
              <FloatingLabel label="Buscar">
                <Form.Control id="search" value={filterText} onChange={ (e) => setFilterText(e.target.value) } placeholder="" />
              </FloatingLabel>
            </Form.Group>
            { filteredItems.length > 0 && 
              <>
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  pagination
                  paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                  persistTableHead
                />
              </>
            }
            { filteredItems.length === 0 && 
              <div>Sin registros</div>
            }
            {/*<Table responsive>
              <thead>
                <tr>
                  <th>Editorial</th>
                  <th>Proveedor</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                { editorasList.length == 0 && 
                  <tr>
                    <td colSpan="6"> <div>Sin registros</div> </td>
                  </tr>
                }
                { editorasList.map( item => (
                  <tr key={ item.idEditora }>
                    <td> 
                      { item.editora }
                    </td>
                    <td>
                      { item.idProveedor ? getNombreProveedor(item.idProveedor).nombre : '-' }
                    </td>
                    { parseInt(rol) === 2 && 
                      <td align="right"> 
                        <PencilFill onClick={ () => showForm(item) } className="table-icon" />
                      </td>
                    }
                  </tr>
                )) }
              </tbody>
            </Table>*/}
          </Col>
        </Row>
      </Container>

    </>
  );
}

export default Editorial;
